/** Route paths. Step components import these, never the route table, so there is no cycle. */
export const paths = {
  welcome: '/welcome',
  store: '/getting-started/store',
  service: '/getting-started/service',
  whatsappConnect: '/getting-started/whatsapp-connect',
  review: '/getting-started/review',
  activate: '/getting-started/activate',
  dashboard: '/dashboard',
} as const;

export const defaultRoutePath = paths.welcome;
